{
  "LOGIN": {
    "TITLE": "Login to Chatwoot",
    "EMAIL": {
      "LABEL": "อีเมล์",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "กรุณากรอกที่อยู่อีเมล์ให้ถูกต้อง"
    },
    "PASSWORD": {
      "LABEL": "หรัสผ่าน",
      "PLACEHOLDER": "หรัสผ่าน"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "ลืมรหัสผ่าน?",
    "CREATE_NEW_ACCOUNT": "สร้างบัญชีใหม่",
    "SUBMIT": "เข้าสู่ระบบ",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
